import { render } from "./paper.vue?vue&type=template&id=0d012713&scoped=true&ts=true"
import script from "./paper.vue?vue&type=script&lang=ts"
export * from "./paper.vue?vue&type=script&lang=ts"

import "./paper.vue?vue&type=style&index=0&id=0d012713&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d012713"]])

export default __exports__